import { EventBus, EventsList } from "../Events/index"
import { Debouncer } from "./index"

const debouncer = new Debouncer()

const handleError = error => {
    console.error(error)
    debouncer.exec(() => {
        EventBus.$emit(
            EventsList.SHOW_EVENT_ERROR,
            error?.response?.data?.message || error?.response?.data?.error || error
        )
    }, 500)
}

export default handleError
